<template>
    <div>
        <div class="animated-background article-card-height"></div>
    </div>
</template>

<script>
    export default {
        name: 'Articles'
    }
</script>



// WEBPACK FOOTER //
// src/components/frontend/content_placeholders/Articles.vue